import request from "./request";

export default {
  // 微信支付
  wechatPayNative: (data) => {
    return request.post("/wechat_pay/native", data);
  },
};
